import React from 'react'
import { Updater } from 'widgets-for-react'
import { async, fromJSX, Widget, any } from 'widgets-for-react'
import { SearchPageState, SearchResult, SearchStateUpdaters } from './searchPageState'
import { SearchPageLayout } from './searchPageLayout'
import { paginationWidget } from '../pagination/paginationWidget'

export const searchPageWidget = (
  state: SearchPageState,
  query: string,
  page: number,
  lang: string,
): Widget<Updater<SearchPageState>> =>
  any<Updater<SearchPageState>>([
    async<SearchResult>(state.searchResultState).map(SearchStateUpdaters.updateSearchResultState),

    fromJSX((setState) => (
      <SearchPageLayout
        items={state}
        oldSearchTerm={query}
        setSearchTerm={(s: string) => setState((state) => ({ ...state, searchTerm: s }))}
        breadcrumbs={
        [
          { title: 'Spaarne Gasthuis', url: lang == 'nl' ? '/' : '/en' },
          lang == 'nl' ? { url: '/zoeken', title: 'Zoeken' } : { url: '/en/search', title: 'Search' },
        ]}
      />
    )),

    paginationWidget(
      page,
      12,
      (newPage: number) => lang == 'nl' ? `/zoeken?query=${query}&page=${newPage}` : `/en/search?query=${query}&page=${newPage}`
    )(state.paginationState).map(SearchStateUpdaters.updatePaginationState),
  ])
